import ax, { LOGIN } from '%/axios';
import CartButton from './CartButton';
import useAuth from '#/useAuth';
import useCategoryProduct from '#/useCategoryProduct';
import ShopCategoryList from './ShopCategoryList';
import SearchBar from '../features/search/components/SearchBar';
import SearchBarResults from '../features/search/components/SearchBarResults';
import { useContext, useState, useEffect, useRef } from 'react';
import SearchContext from '^/SearchContext';
import useOutsideHandler from '#/useOutsideHandler';
import useSeoLinks from '../hooks/useSeoLinks';
const IS_MOBILE = window.innerWidth < 991;

const Navigation = () => {

  const {
    auth,
    logout
  } = useAuth();

  const {
    search,
    searchResults,
    setSearchResults
  } = useContext(SearchContext);

  const [show, setShow] = useState(false);

  const {
    seoLinks
  } = useSeoLinks();
  const handleClickOutside = () => {
    setShow(false);
  }

  const ref = useRef(null);
  useOutsideHandler(ref, handleClickOutside);

  const { catProd } = useCategoryProduct();



  return (
    <div data-w-id="b47b0abe-f790-eb04-0d49-908f9d38f267" className="nav-wrapper">
      <div data-collapse="medium" data-animation="default" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" className="nav-standard nav-banner-wrapper w-nav">
        <div data-w-id="87cde0fb-c226-a4a9-69c7-a0cdb8c7f18a" className="nav">
          <div className="nav-menu-wrapper">
            <div className="nav-left-wrapper">
              <a href="/" data-w-id="b47b0abe-f790-eb04-0d49-908f9d38f276" className="logo-link w-inline-block"><img src={assetPre + "images/DSS-3D-BW.webp"} loading="lazy" sizes="(max-width: 767px) 75px, (max-width: 991px) 100px, 150px"
                alt="" className="image" /></a>
              <div className="form-block-search w-form">
                <div id="email-form" name="email-form" data-name="Email Form" method="get">
                  <div
                    ref={ref}
                    className="search-bar-wrapper">
                    <SearchBar
                      setShow={setShow}

                    />
                    {
                      (show && (search)) &&
                      <SearchBarResults />
                    }
                    <div className="search-icon w-embed"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="7.84442" cy="7.84442" r="5.99237" stroke="#B3B3B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></circle>
                      <path d="M12.0122 12.3235L14.3616 14.6667" stroke="#B3B3B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg></div>
                  </div>
                </div>
                <div className="w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div className="w-form-fail">
                  <div>Oops! Something went wrong while submitting the form.</div>
                </div>
              </div>
            </div>
            <div className="nav-right-wrapper">
              {
                window.innerWidth <= 991 &&
                <CartButton
                  hideText
                />
              }
              {
                window.innerWidth > 480 &&
                <div className="nav-phone-wrapper">
                  <div className="nav-phone-icon w-embed">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 16.42V19.956C21.0001 20.2092 20.9042 20.453 20.7316 20.6382C20.559 20.8234 20.3226 20.9363 20.07 20.954C19.633 20.984 19.276 21 19 21C10.163 21 3 13.837 3 5C3 4.724 3.015 4.367 3.046 3.93C3.06372 3.67744 3.17658 3.44101 3.3618 3.26841C3.54703 3.09581 3.79082 2.99989 4.044 3H7.58C7.70404 2.99987 7.8237 3.04586 7.91573 3.12902C8.00776 3.21218 8.0656 3.32658 8.078 3.45C8.101 3.68 8.122 3.863 8.142 4.002C8.34073 5.38892 8.748 6.73783 9.35 8.003C9.445 8.203 9.383 8.442 9.203 8.57L7.045 10.112C8.36445 13.1865 10.8145 15.6365 13.889 16.956L15.429 14.802C15.4919 14.714 15.5838 14.6509 15.6885 14.6237C15.7932 14.5964 15.9042 14.6068 16.002 14.653C17.267 15.2539 18.6156 15.6601 20.002 15.858C20.141 15.878 20.324 15.9 20.552 15.922C20.6752 15.9346 20.7894 15.9926 20.8724 16.0846C20.9553 16.1766 21.0012 16.2961 21.001 16.42H21Z" fill="currentColor"></path>
                    </svg>
                  </div>
                  <div>Sales:</div>
                  <a href="/contact-us" className="nav-banner-link">Contact Us</a>
                </div>
              }
              <div className="nav-line-break"></div>
              <div className="nav-icon-wrapper">
                <CartButton />
              </div>
              <div className="nav-line-break"></div>

              <div className="nav-button-wrapper">
                {
                  auth.id ?
                    <>
                      <div>
                        Welcome, {auth.fname}
                      </div>
                      <a className="w--current cursor-ptr"
                        href='/account'
                      >Account</a>
                      <a
                        className="w--current cursor-ptr"
                        onClick={() => logout()}>Sign out</a>
                    </>
                    :
                    <div style={{ width: '100%' }}>
                      <a
                        href={seoLinks['auth.login']}
                        className="button-register w-button"
                        >Sign In or Create an Account</a>
                      {/* <div className="paragraph-16"
                        style={{
                          color: '#EEE', fontSize: 16,
                          maxWidth: 302
                        }}
                      >
                        <strong>
                          We have a new e-commerce platform, please create a new account.
                        </strong>
                      </div> */}
                    </div>
                }
              </div>


            </div>
          </div>
          <div className="nav-right-wrapper">
            <nav role="navigation" className="nav-menu w-nav-menu">
              <div
                style={{
                  alignSelf: 'center'
                }}
                data-hover="false" data-delay="0" data-w-id="b7d6c3d5-9018-8e2d-7c22-25cd7b5b16a9" className="nav-dropdown w-dropdown">
                <div className="nav-toggle w-dropdown-toggle">
                  <div>Shop</div>
                </div>
                <nav className="dropdown-list-wrapper w-dropdown-list" id="w-dropdown-list-0"
                  aria-labelledby="w-dropdown-toggle-0">
                  <div className="nav-dropdown-container">
                    <div className="w-layout-grid nav-grid-large">
                      <div id="w-node-b7d6c3d5-9018-8e2d-7c22-25cd7b5b16b0-9d38f267"
                        className="nav-menu-collection-list-wrapper w-dyn-list">
                        <div role="list" className="w-dyn-items">
                          <div role="listitem" className="w-dyn-item">
                            <div className="nav-link-cta">
                              <div className="nav-content">
                                <p className="paragraph-regular category-nav-banner-title">The Dana Safety Supply
                                  Store.<br />Everything you need. Ready to deliver.</p><a href="#"
                                    className="shop-all-button w-button" tabIndex="0">Shop All →</a>
                              </div><img
                                src="https://assets-global.website-files.com/633f21b6d2a6d32f41acea31/638e197ff8330ebc303a6118_Emergency%20Lights.png"
                                loading="lazy" alt="" sizes="100vw"
                                srcSet="https://assets-global.website-files.com/633f21b6d2a6d32f41acea31/638e197ff8330ebc303a6118_Emergency%20Lights-p-500.png 500w, https://assets-global.website-files.com/633f21b6d2a6d32f41acea31/638e197ff8330ebc303a6118_Emergency%20Lights-p-800.png 800w, https://assets-global.website-files.com/633f21b6d2a6d32f41acea31/638e197ff8330ebc303a6118_Emergency%20Lights-p-1080.png 1080w, https://assets-global.website-files.com/633f21b6d2a6d32f41acea31/638e197ff8330ebc303a6118_Emergency%20Lights-p-1600.png 1600w, https://assets-global.website-files.com/633f21b6d2a6d32f41acea31/638e197ff8330ebc303a6118_Emergency%20Lights-p-2000.png 2000w, https://assets-global.website-files.com/633f21b6d2a6d32f41acea31/638e197ff8330ebc303a6118_Emergency%20Lights-p-2600.png 2600w, https://assets-global.website-files.com/633f21b6d2a6d32f41acea31/638e197ff8330ebc303a6118_Emergency%20Lights.png 3000w"
                                className="nav-category-banner" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div id="w-node-b7d6c3d5-9018-8e2d-7c22-25cd7b5b16bf-9d38f267"
                        className="nav-dropdown-link-wrapper">
                        <p className="paragraph-regular category-nav-banner-title gradient-span"><span
                          className="gradient-span">The Dana Safety Supply Store.</span><br />Everything you need. Ready
                          to deliver.</p>
                        <div className="w-dyn-list">
                          <div role="list" className="nav-categories-collection-list w-dyn-items">
                            <div role="listitem" className="w-dyn-item"><a href={seoLinks['ballistic-glass']}
                              className="nav-link-dropdown w-inline-block" tabIndex="0">
                              <div>BallisTech</div>
                            </a></div>
                            <ShopCategoryList
                              list={catProd.categories.list}
                            />
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </nav>
              </div>
              <a
                href='https://events.danasafetysupply.com/'
                className="nav-link w-inline-block">
                <div>Events</div>
              </a>

              <a href={seoLinks['ballistic-glass']} className="nav-link ballistech w-inline-block">
                <div>Ballistic Glass</div>
                <div className="ballistech-nav-badge">
                  <div>New</div>
                </div>
              </a>
              <a href={seoLinks['upfitting']} className="nav-link w-inline-block">
                <div>Vehicle Installations</div>
              </a>
              <a href={seoLinks['locations.index']} className="nav-link w-inline-block">
                <div>Locations</div>
              </a>
              <a href={seoLinks.careers} className="nav-link w-inline-block">
                <div>Careers</div>
              </a>
              <a href={seoLinks['about-us']} className="nav-link w-inline-block">
                <div>About</div>
              </a>
              {/* <a href={seoLinks['contact-us']} aria-current="page" className="nav-link w-inline-block">
                <div>Contact Us</div>
              </a> */}
              {/* <div data-hover="false" data-delay="0" className="nav-dropdown w-dropdown">
                <div className="nav-toggle w-dropdown-toggle">
                  <div>Shop by Brand</div>
                </div>
              </div> */}
              <div data-hover="false" data-delay="0" data-w-id="b7d6c3d5-9018-8e2d-7c22-25cd7b5b16dc" className="nav-dropdown w-dropdown">
                <div className="nav-toggle w-dropdown-toggle">
                  <div>More Info</div>
                </div>
                <nav className="dropdown-list-wrapper w-dropdown-list">
                  <div className="nav-dropdown-container">
                    <div className="w-layout-grid nav-grid-large">
                      <div id="w-node-b7d6c3d5-9018-8e2d-7c22-25cd7b5b16e3-9d38f267" className="nav-dropdown-link-wrapper no-bottom">
                        <div className="nav-heading-detail">Company</div>
                        <div className="w-layout-grid nav-dropdown-collection-list more-info">
                          <a href={seoLinks['about-us']} className="nav-link-dropdown w-inline-block">
                            <div>About Us</div>
                          </a>
                          <a href={seoLinks['message-from-our-ceo']} className="nav-link-dropdown w-inline-block">
                            <div>A Message From Our CEO</div>
                          </a>
                          <a href={seoLinks['contact-us']} aria-current="page" className="nav-link-dropdown w-inline-block w--current">
                            <div>Contact Us</div>
                          </a>
                          <a href={seoLinks['auth.register']} className="nav-link-dropdown w-inline-block">
                            <div>Login/Register</div>
                          </a>
                        </div>
                      </div>
                      <div id="w-node-b7d6c3d5-9018-8e2d-7c22-25cd7b5b16f3-9d38f267" className="nav-dropdown-link-wrapper no-bottom">
                        <div className="nav-heading-detail-wrapper">
                          <div className="nav-heading-detail">Locations</div>
                          <a href={seoLinks['locations.index']} className="nav-heading-link">All Locations →</a>
                        </div>
                      </div>
                      <div id="w-node-b7d6c3d5-9018-8e2d-7c22-25cd7b5b1703-9d38f267" className="nav-dropdown-link-wrapper no-bottom">
                        <div className="nav-heading-detail">Resources &amp; Policies</div>
                        <div className="w-layout-grid nav-dropdown-collection-list more-info">
                          <a href={seoLinks['careers']} className="nav-link-dropdown w-inline-block">
                            <div>Careers</div>
                          </a>
                          <a href={seoLinks.testimonials} className="nav-link-dropdown w-inline-block">
                            <div>Customer Testimonials</div>
                          </a>
                          {/* <a href={seoLinks['covid-19-relief-fund']} className="nav-link-dropdown w-inline-block">
                            <div>COVID-19 Relief Fund</div>
                          </a> */}
                          <a href="/frequently-asked-questions" className="nav-link-dropdown w-inline-block">
                            <div>FAQ&#x27;s</div>
                          </a>
                          {/* <a href={seoLinks['gift-certificates']} className="nav-link-dropdown w-inline-block">
                            <div>Gift Certificates</div>
                          </a> */}
                          <a href="/how-to-order" className="nav-link-dropdown w-inline-block">
                            <div>How to Order</div>
                          </a>
                          <a href={seoLinks['gsa-ordering']} className="nav-link-dropdown w-inline-block">
                            <div>GSA Ordering</div>
                          </a>
                          <a href={seoLinks['eeo-policy']} className="nav-link-dropdown w-inline-block">
                            <div>EEO Policy</div>
                          </a>
                          <a href={seoLinks['privacy-policy']} className="nav-link-dropdown w-inline-block">
                            <div>Privacy Policy</div>
                          </a>
                          <a href="/request-a-quote" className="nav-link-dropdown w-inline-block">
                            <div>Request a Quote</div>
                          </a>
                          <a href={seoLinks['shipping-returns']} className="nav-link-dropdown w-inline-block">
                            <div>Shipping &amp; Returns</div>
                          </a>
                          <a href="/news" className="nav-link-dropdown w-inline-block">
                            <div>News &amp; Updates</div>
                          </a>
                          <a href="/installations-gallery" className="nav-link-dropdown w-inline-block">
                            <div>Installation Builds</div>
                          </a>
                          {/* <a href={seoLinks['oklahoma-fire-city-contract']} className="nav-link-dropdown w-inline-block">
                            <div>Oklahoma City Fire Contract</div>
                          </a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </nav>
              </div>

              {
                IS_MOBILE &&
                (
                  auth.id ?
                    <>
                      <div style={{ marginBottom: 8 }}>
                        Welcome, {auth.fname}
                      </div>
                      <a className="w--current cursor-ptr"
                        href='/account'
                      >Account</a>
                      <div style={{ height: 8 }}></div>
                      <a
                        className="w--current cursor-ptr"
                        onClick={() => logout()}>Sign out</a>
                    </>
                    :
                    <>
                      <a href={seoLinks['auth.register']} className="nav-link w-inline-block">
                        <div>Sign In or Create an Account</div>
                      </a>
                      {/* <div className="paragraph-16 nav-link inline-block"
                        style={{
                          color: '#EEE', fontSize: 16,
                          maxWidth: 302,
                          textAlign: 'left'
                        }}
                      >
                        <strong>
                          Existing customers: we have a new e-commerce platform, please create a new account.
                        </strong>
                      </div> */}
                    </>

                )
              }
            </nav>
            <div className="menu-button w-nav-button">
              <div className="w-icon-nav-menu"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Navigation;
